import React from "react";
import { Link } from "react-router-dom";
import Chooseimg1 from "../../assets/images/resources/about-circle-1.png";
import Chooseimg2 from "../../assets/images/resources/about-circle-2.png";
import ChooseShape from "../../assets/images/shapes/about-circle-shape.png";

function Whychoose() {
  const circleTextOptions = {
    radius: 92,
    forceWidth: true,
    forceHeight: true,
  };

  return (
    <div>
      <section className="why-choose-two">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div className="why-choose-two__image">
                <img src={Chooseimg1} alt="" />
                <img
                  src={Chooseimg2}
                  className="why-choose-two__image__two"
                  alt=""
                />
                <img
                  src={ChooseShape}
                  className="why-choose-two__image__shape"
                  alt=""
                />
                <div className="why-choose-two__circle">
                  <span className="video-popups">
                    <i className="icon-talent-search" />
                  </span>
                  <div className="curved-circle">
                    <div
                      className="curved-circle--item"
                      data-circle-text-options='{
                                                "radius": 92,
                                                "forceWidth": true,
                                                "forceHeight": true
                                            }'
                    >
                      connecting talent with opportunity
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="why-choose-two__content">
                <div className="sec-title text-left">
                  <h6 className="sec-title__tagline">Why Choose Hirelyxon</h6>
                  <h3 className="sec-title__title">
                    Your Trusted Partner for <br />
                    Recruitment & HR Solutions
                  </h3>
                </div>
                <p className="why-choose-two__text">
                  We help organizations hire the right talent while supporting
                  professionals in building successful careers through reliable,
                  efficient, and customized HR solutions.
                </p>
                <ul className="why-choose-two__feature">
                  <li>
                    <i className="fas fa-check-circle" />
                    Industry-Specific Recruitment Expertise
                  </li>
                  <li>
                    <i className="fas fa-check-circle" />
                    Candidate-Centric Career Support
                  </li>
                </ul>
                <div className="why-choose-two__progress">
                  <h4 className="why-choose-two__progress__title">
                    Recruitments
                  </h4>
                  <div className="why-choose-two__progress__bar">
                    <div
                      className="why-choose-two__progress__inner count-bar"
                      style={{ width: "80%" }}
                    >
                      <div
                        className="why-choose-two__progress__inner count-bar counted"
                        data-percent="80%"
                      >
                        <div className="why-choose-two__progress__number count-text">
                          80%
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Link to="/services" className="hiredots-btn">
                  <span>Discover More</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Whychoose;
